import { createStore } from 'vuex'
import axios from "axios";
import { COMPANY_INFO } from "@/constant";
import {getCookie, setCookie} from "@/utils/cookies";

const COZE_TOKEN = 'coze_access_token'
const COZE_EXPIRE = 'coze_access_token_expire'
const CLIENT_ID = 'client_id'

export default createStore({
  state: {
    locale: '',
    companyInfo: JSON.parse(window.localStorage.getItem(COMPANY_INFO)) || null,
    cozeAccessToken: getCookie(COZE_TOKEN) || '',
    cozeAccessTokenExpire: window.localStorage.getItem(COZE_EXPIRE) || null,
    clientId: window.localStorage.getItem(CLIENT_ID) || null
  },
  mutations: {
    setLanguage(state, payload) {
      state.locale = payload.value;
      window.localStorage.setItem('locale', payload.value);
    },
    changeLanguage(state, language) {
      state.locale = language
    },
    setCompanyInfo(state, companyInfo) {
      state.companyInfo = companyInfo
      window.localStorage.setItem(COMPANY_INFO, JSON.stringify(companyInfo))
    },
    setCozeAccessToken(state, token) {
      const expires_in = token.expires_in; // 后端时间戳（秒）
      state.cozeAccessToken = token.access_token
      state.cozeAccessTokenExpire = expires_in

      window.localStorage.setItem(COZE_EXPIRE, expires_in)

      const currentTime = Math.floor(Date.now() / 1000); // 当前时间戳（秒）
      const remainingDays = Math.ceil((expires_in - currentTime) / 86400);
      setCookie(COZE_TOKEN, token.access_token, { expires: new Date(expires_in * 1000) })
    },
    setClientId(state, clientId) {
      state.clientId = clientId
      window.localStorage.setItem(CLIENT_ID, clientId)
    }
  },
  actions: {
    getLanguage(context) {
      let language = ''
      if (!window.localStorage.getItem('locale')) {
        const supportedLocales = ['zh-CN', 'en-US', 'de-DE', 'jp-JP'];
        const browserLang = navigator.language;

        if (browserLang === 'ja')
          language = 'jp-JP'
        else
          language = supportedLocales.find(loc => loc.startsWith(browserLang.split('-')[0])) || 'en-US';

      } else {
        language = window.localStorage.getItem('locale')
      }

      context.commit('changeLanguage', language)
    },

    async getCompanyInfo(context) {
      const res = await axios.get('/api/api/company/show')
        .catch(err => {
          throw new Error(err.message)
        })
      context.commit('setCompanyInfo', res.data)
    },

    async getCozeAccessToken(context) {
      const { state } = context;

      // 如果 token 未过期，直接返回
      if (
        state.cozeAccessToken &&
        state.cozeAccessTokenExpire > Math.floor(Date.now() / 1000)
      ) {
        return state.cozeAccessToken;
      }

      const res = await axios.get(`/api/api/coze?clientId=${context.state.clientId}`)
        .catch(err => {
          throw new Error(err.message)
        })
      context.commit('setCozeAccessToken', res.data)
    }
  },
  getters: {
    currentLanguage(state) {
      const lang = {
        'zh-CN': 'cn',
        'en-US': 'en',
        'de-DE': 'de',
        'jp-JP': 'jp'
      }

      return lang[state.locale]
    },

    cozeExpireTime(state) {
      return state.cozeAccessTokenExpire
    },

    clientId(state) {
      return state.clientId
    }
  }
})
